//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"FloorOrientationType",1,0],[0,"Offset",1,1],[1,"OffsetExpression",0,"Expression",0],[0,"Size",1,1],[1,"SizeExpression",0,"Expression",0],[0,"SpecifyFloorPlane",1,"Plane",0]],[[[],"FloorXaxis",{},0,0],[[],"FloorYaxis",{},0,0],[[],"FloorZaxis",{},0,0],[["specifyFloorPlane"],"AlignFloorPlane",{},1,0],[["index"],"GetWallFromList",{R_:{wall:"Display.Wall"}},1,0],[["index","wall"],"SetWallInList",{},2,0],[["view","current_wall_index","update_stage_database"],"CommitWall",{},3,0],[["view"],"CommitOffset",{},1,0]],[]];
SPLM.Display.Stage = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.Stage";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.Stage.WallType = Object.freeze({
    "Left" : "Left", "Right" : "Right", "Top" : "Top", "Bottom" : "Bottom", "Front" : "Front", "Back" : "Back", "Total" : "Total"});

SPLM.Display.Stage.OrientationType = Object.freeze({
    "Yz" : "Yz", "Xz" : "Xz", "Xy" : "Xy", "UserDefined" : "UserDefined"});

export default SPLM;